import { useEffect, useRef, useState } from 'react';
import { useLang } from '../i18n';

const testimonials = [
  { name: 'Mike T.', vehicle: '2023 Ford Mustang GT', quote_en: "Finally found a shop that knows their stuff. Got a Flowmaster setup on my Mustang and it sounds absolutely mean. Fast, clean install and a fair price. Won't go anywhere else.", quote_es: 'Por fin encontr\u00e9 un taller que sabe lo que hace. Me pusieron un Flowmaster en mi Mustang y suena incre\u00edble. Instalaci\u00f3n r\u00e1pida, limpia y a buen precio. No ir\u00e9 a otro lugar.', type_en: 'Enthusiast', type_es: 'Entusiasta' },
  { name: 'Sandra R.', vehicle: '2019 Honda Accord', quote_en: "Came in for a rattle I had been ignoring for months. Fixed in 30 minutes and they didn't try to upsell me on anything I didn't need. Refreshingly honest. Rare these days.", quote_es: 'Vine por un ruido que hab\u00eda ignorado por meses. Lo arreglaron en 30 minutos y no intentaron venderme nada que no necesitara. Refrescantemente honestos. Raro hoy en d\u00eda.', type_en: 'Daily Driver', type_es: 'Auto Diario' },
  { name: 'Jake M.', vehicle: '2022 RAM 2500 Diesel', quote_en: 'Brought in my diesel for a full MBRP exhaust build. These guys know their trucks. Done same day, runs perfectly. The shop is legit \u2014 highly recommend to any truck owner.', quote_es: 'Traje mi diesel para una construcci\u00f3n completa de escape MBRP. Estos tipos saben de camionetas. Terminado el mismo d\u00eda, funciona perfecto. El taller es leg\u00edtimo \u2014 lo recomiendo mucho.', type_en: 'Truck Owner', type_es: 'Due\u00f1o de Camioneta' },
];

function StarIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  );
}

export default function Testimonials() {
  const [visible, setVisible] = useState(false);
  const ref = useRef();
  const { lang, t } = useLang();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.disconnect(); } },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="testimonials-section sm-section" data-testid="testimonials" ref={ref}>
      <div className="sm-container">
        <div className="reveal-item" style={visible ? { opacity: 1, transform: 'translateY(0)' } : {}}>
          <div className="section-label">{t.testLabel}</div>
          <h2 className="section-title">{t.testTitle}</h2>
          <p className="section-subtitle">{t.testSubtitle}</p>
        </div>
        <div className="testimonials-grid" data-testid="testimonials-grid">
          {testimonials.map((tm, i) => (
            <div key={i} className="testimonial-card reveal-item" style={{ transitionDelay: `${i * 90}ms`, ...(visible ? { opacity: 1, transform: 'translateY(0)' } : {}) }}>
              <div className="testimonial-stars" aria-label="5 out of 5 stars">
                {[...Array(5)].map((_, j) => <StarIcon key={j} />)}
              </div>
              <p className="testimonial-quote">&ldquo;{lang === 'es' ? tm.quote_es : tm.quote_en}&rdquo;</p>
              <div className="testimonial-author">
                <div className="testimonial-name">{tm.name}</div>
                <div className="testimonial-vehicle">{tm.vehicle} &middot; {lang === 'es' ? tm.type_es : tm.type_en}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
